module.exports = __webpack_public_path__ + "img/fritz-pantry-landscape-576w.b19d05cf.jpg";